





import { defineComponent } from "@vue/composition-api";
import router from "@/router";
import queryString from "query-string";
import Loading from "@/components/Loading.vue";

export default defineComponent({
  components: { Loading },
  setup() {
    const query = router.currentRoute.query;
    if (query.oidc) {
      const oidcQuery = queryString.parse(query.oidc as string);
      const response = queryString.stringify({
        state: oidcQuery.state,
        nonce: oidcQuery.nonce,
        code: query.session_id,
      });
      // fix wrong port number in the redirect uri
      const uri = oidcQuery.redirect_uri as string;
      window.location.href = uri + "?" + response;
    } else {
      router.push({
        name: "pre-login",
        query: { oidc: queryString.stringify(router.currentRoute.query) },
      });
    }
  },
});
